import api from "@/services/api";

export default {
  get(params) {
    return api().get("admin/master/test-kit/get/" + params.id);
  },
  create(params) {
    return api().post("admin/master/test-kit/create", params);
  },
  update(params) {
    return api().post("admin/master/test-kit/update", params);
  },
  status(params) {
    return api().post("admin/master/test-kit/change-status", params);
  },
  list(params) {
    return api().post("admin/master/test-kit/list", params);
  },
  delete(params) {
    return api().post("admin/master/test-kit/delete", params);
  },
  restore(params) {
    return api().post("admin/master/test-kit/restore", params);
  },
  order(params) {
    return api().post("admin/master/test-kit/change-order", params);
  }
};
